export const badge ={
    baseStyle: {        
        rounded: '2px',        
        px: 2,                
        transition: "all 0.3s ease-in",
        textTransform: 'capitalize',
        fontWeight: "500",
        fontSize: "14px"
    },
    sizes:{
              
    },
    variants:{

    },
    defaultProps:{
        colorScheme: "orange"
    }
}